import React, { useEffect, useMemo, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Link, useLocation, useParams } from "react-router-dom"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../../components/Common/TableContainer"

//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"

import {
  Event_Description,
  Package,
  PaidDate,
  PurchaseAmount,
  PurchaseDate,
  Vendor_name,
} from "./ReviewsListCol"

//redux
import { useSelector, useDispatch } from "react-redux"
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
} from "reactstrap"
import DeleteModal from "../../../components/Common/DeleteModal"
import {
  deletePurchase,
  getPurchases,
  updatePurchase,
} from "../../../store/purchases/actions"
import {
  deleteReview,
  getReviews,
  updateReview,
} from "../../../store/reviews/actions"
import ConfirmModal from "../../../components/Common/confirmModal"

function Reviews() {
  let params = useParams()
  let location = useLocation()
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [query, setQuery] = useState("")
  const [date, setDate] = useState("")
  const [ceremony_pack, setCeremony] = useState([])
  const [offset, setOffset] = useState(0)
  const [page_size, setPageSize] = useState(10)

  const dispatch = useDispatch()
  const purchases = useSelector(state => state.reviews.data)
  const total_page = useSelector(state => state.reviews.total_page)
  const loading = useSelector(state => state.reviews.loading)
  const [reviewStatus, setreviewStatus] = useState({
    id: 0,
    status: 0,
    vendor_id: 0,
  })

  useEffect(() => {
    dispatch(getReviews({ offset, page_size }))
  }, [dispatch, offset, page_size])

  useEffect(() => {
    if (!isEmpty(purchases)) {
      setIsEdit(false)
    }
  }, [purchases])

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false)
      setCeremony(null)
    } else {
      setModal(true)
    }
  }, [modal])
  console.log(date)
  useEffect(() => {
    if (query || date) {
      setTimeout(() => {
        dispatch(getReviews({ offset, page_size, query, date: date[0] }))
      }, 500)
    }
  }, [dispatch, query, date])

  //delete ceremony_pack
  const [deleteModal, setDeleteModal] = useState(false)
  const [confirmModal, setconfirmModal] = useState(false)
  const onClickDelete = ceremony_pack => {
    setCeremony(ceremony_pack)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (ceremony_pack.id) {
      dispatch(deleteReview(ceremony_pack))
      // setDeleteModal(false)
    }
  }
  useEffect(() => {
    if (!loading) {
      setDeleteModal(false)
      setModal(false)
    }
  }, [loading])
  const handleUserClicks = () => {
    setIsEdit(false)
    toggle()
  }
  const UpdateActiveStatus = () => {
    if (reviewStatus.vendor_id != null) {
      dispatch(
        updateReview({
          is_active: reviewStatus.status,
          id: reviewStatus.id,
          vendor_id: reviewStatus.vendor_id,
        })
      )
    } else {
      dispatch(
        updateReview({
          is_active: reviewStatus.status,
          id: reviewStatus.id,
        })
      )
    }
    setconfirmModal(false)
  }

  const ChangeActiveStatus = ({ id, status, vendor_id }) => {
    setreviewStatus({
      id: id,
      status: status,
      vendor_id: vendor_id,
    })
    setconfirmModal(true)
  }

  const columns = useMemo(
    () => [
      // {
      //   Header: "Id",
      //   accessor: "checkbox",
      //   disableFilters: true,
      //   filterable: false,
      //   Cell: cellProps => {
      //     return <input type="checkbox" className="selection-input-4" />
      //   },
      // },
      {
        Header: "Client",
        accessor: "clients_name",
        filterable: true,
        Cell: cellProps => {
          return <Event_Description {...cellProps} />
        },
      },
      {
        Header: "Vendor",
        accessor: "vendor_name",
        filterable: true,
        Cell: cellProps => {
          return <Vendor_name {...cellProps} cellp={cellProps} />
        },
      },
      {
        Header: "date",
        accessor: "review_date",
        filterable: true,

        Cell: cellProps => {
          return <Package {...cellProps} />
        },
      },
      {
        Header: "Review details",
        accessor: "text",
        filterable: true,

        Cell: cellProps => {
          return <PurchaseAmount {...cellProps} />
        },
      },
      {
        Header: "Active",
        accessor: "is_active",
        filterable: true,
        disableFilters: true,

        Cell: cellProps => (
          <div className="form-check form-switch form-switch-lg">
            {cellProps.value == 1 ? (
              <input
                disabled={loading}
                onClick={e => {
                  ChangeActiveStatus({
                    id: cellProps.row.original.id,
                    status: 0,
                    vendor_id: null,
                  })
                }}
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={true}
              />
            ) : (
              <input
                disabled={loading}
                onClick={e => {
                  ChangeActiveStatus({
                    id: cellProps.row.original.id,
                    status: 1,
                    vendor_id: cellProps.row.original.vendor_id,
                  })
                }}
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={false}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const purchases = cellProps.row.original
                      onClickDelete(purchases)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
              </ul>
            </div>
          )
        },
      },
    ],
    [loading]
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
      />
      <ConfirmModal
        show={confirmModal}
        onConfirmClick={UpdateActiveStatus}
        onCloseClick={() => setconfirmModal(false)}
        loading={loading}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="MENU" breadcrumbItem={"Reviews"} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    date={date}
                    setDate={setDate}
                    columns={columns}
                    data={purchases}
                    isGlobalFilter={true}
                    // isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                    setPage={setOffset}
                    page_number={offset}
                    total_pages={total_page}
                    setPageSize={setPageSize}
                    page_size={page_size}
                    setQuery={q => setQuery(q)}
                    query={query}
                    isDate
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit User" : "Add Users"}
            </ModalHeader>
            <ModalBody></ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
Reviews.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Reviews
